// Dipende da src/components/animations/useScrollPin.js del progetto (stack scroll-experience).
import { useScrollPin } from '@/components/animations/useScrollPin';
import { SlideMedia } from './SlideMedia';

/**
 * Sezione pinnata full-viewport: crossfade sequenziale tra N "scene" mentre
 * si scrolla (non più fissa a due). Ogni scena può avere un media (immagine
 * o video) di sfondo, testo e CTA opzionale — `showOverlay` disattiva testo
 * e scrim insieme, per una scena puramente visiva.
 * @param {{ scenes?: Array<{ mediaType?: 'image'|'video', image?: string, imageAlt?: string, videoUrl?: string, showOverlay?: boolean, title: string, ctaLabel?: string, ctaHref?: string }> }} props
 */
export function PinnedRevealBlock({ scenes = [] }) {
  const count = Math.max(scenes.length, 1);
  const ref = useScrollPin(
    (tl) => {
      for (let i = 0; i < count - 1; i++) {
        tl.to(`.pin-scene-${i}`, { opacity: 0, scale: 0.92, duration: 1 })
          .fromTo(`.pin-scene-${i + 1}`, { opacity: 0, scale: 1.08 }, { opacity: 1, scale: 1, duration: 1 }, '<');
      }
    },
    { end: '+=' + Math.max(150, count * 120) + '%' }
  );

  return (
    <section ref={ref} className="relative h-screen overflow-hidden bg-theme-bg-subtle">
      {scenes.map((scene, i) => {
        const hasMedia = scene.mediaType === 'video' ? !!scene.videoUrl : !!scene.image;
        const showOverlay = scene.showOverlay !== false;
        return (
          <div
            key={i}
            className={`pin-scene-${i} absolute inset-0 flex flex-col items-center justify-center gap-6 text-center px-6`}
            style={{ opacity: i === 0 ? 1 : 0 }}
          >
            {hasMedia && (
              <>
                <SlideMedia
                  mediaType={scene.mediaType}
                  image={scene.image}
                  imageAlt={scene.imageAlt}
                  videoUrl={scene.videoUrl}
                  fallbackAlt={scene.title}
                  className="-z-10"
                />
                {showOverlay && <div className="absolute inset-0 bg-black/35 -z-10" />}
              </>
            )}
            {showOverlay && (
              <>
                <h2 className={'font-heading text-h1 font-light ' + (hasMedia ? 'text-white' : i % 2 === 1 ? 'text-theme-accent' : 'text-theme-text')}>
                  {scene.title}
                </h2>
                {scene.ctaLabel && (
                  <a
                    href={scene.ctaHref || '#'}
                    className="inline-flex items-center px-7 py-3 rounded-lg bg-theme-accent text-theme-accent-text text-sm font-medium tracking-wide"
                  >
                    {scene.ctaLabel}
                  </a>
                )}
              </>
            )}
          </div>
        );
      })}
    </section>
  );
}
